import * as yup from 'yup';
export default (data) =>
{
  let schema = yup.object().shape({
    name: yup.string().optional().default(""),
    });

    try {
      schema.validateSync({...data});
      return {status: 'success', data: {...data}};
    } catch (error) {
      return {status: 'failure', message: error.errors[0]}
    }
}